import React from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
import { useGate } from '../../contexts/GateContext';

const AuthGateModal = () => {
    const { authModalOpen, authMessage, closeAuthGate } = useGate();

    if (!authModalOpen) return null;

    const next = encodeURIComponent(`${window.location.pathname}${window.location.search}`);

    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
            <div
                role="dialog"
                aria-modal="true"
                className="relative w-full max-w-md rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 shadow-xl p-6"
            >
                <button
                    type="button"
                    onClick={closeAuthGate}
                    className="absolute top-3 right-3 p-1 rounded-lg text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800"
                    aria-label="Close"
                >
                    <X className="w-5 h-5" />
                </button>
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white pr-8">Continue with an account</h2>
                <p className="mt-2 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">{authMessage}</p>
                <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <Link
                        to={`/login?next=${next}`}
                        onClick={closeAuthGate}
                        className="flex-1 text-center rounded-lg bg-blue-600 text-white text-sm font-semibold py-2.5 hover:bg-blue-700 transition-colors"
                    >
                        Log In
                    </Link>
                    <Link
                        to={`/login?next=${next}`}
                        onClick={closeAuthGate}
                        className="flex-1 text-center rounded-lg border border-gray-300 dark:border-gray-600 text-sm font-semibold py-2.5 text-gray-800 dark:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
                    >
                        Sign Up
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default AuthGateModal;
